import { Col, Modal, Row } from 'antd';
import React from 'react';
import CIBLogo from '../../../assets/images/cib-logo.png';
import configProxy from '../../../utils/config';
import { ButtonType, TAButton } from '../../widgets';
const OfflinePaymentModal = ({ visible, onCancel }) => {
	return (
		<Modal width={600} footer={null} visible={visible} onCancel={onCancel}>
			<div className="w-100">
				<Row className="mb-3">
					<h2 style={{ fontSize: '1.5rem' }}>Bank Details</h2>
				</Row>
				<Row>
					<div
						className="d-flex mb-2"
						style={{
							borderRadius: '5px',
							padding: '10px',
							width: '100%'
						}}
					>
						<div
							style={{ height: 'auto' }}
							className="d-flex me-4  flex-column justify-content-between align-items-left"
						>
							<span style={{ fontWeight: 500 }} className="mb-1">
								Bank Name
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								Account Name
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								Account Number
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								Swift Code
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								Currency
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								Branch
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								Company Address
							</span>
						</div>
						<div style={{ height: '90px' }} className="d-flex justify-content-between flex-column">
							<span>
								{' '}
								<img style={{ width: '30px', marginRight: '6px' }} alt="CIB logo" src={CIBLogo} />
								CIB Bank
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								{configProxy.companyName}
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								{configProxy.accountNumber}
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								{configProxy.swiftCode}
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								{configProxy.currency}
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								{configProxy.branch}
							</span>
							<span style={{ fontWeight: 500 }} className="mb-1">
								{configProxy.companyAddress}
							</span>
						</div>
					</div>
				</Row>
				<Row className="d-flex justify-content-center">
					<TAButton btntype={ButtonType.PRIMARY} onClick={onCancel}>
						Done
					</TAButton>
				</Row>
			</div>
		</Modal>
	);
};

export default OfflinePaymentModal;
